/*
 * IO-5815 - Kaching Bundles on the LT product page: the pure (price / placeholder / badge) half.
 *
 * <kaching-bundles-ui> (assets/product-main.js) renders the deal Kaching's app embed ships in
 * script.kaching-bundles-deal-block-settings with our own markup. Everything here is a port of
 * what Kaching's own widget (kaching-bundles-block.js) computes, so a price / placeholder / badge
 * shown on our PDP is the one Kaching's checkout Function will charge. It deliberately holds no
 * state and only touches the DOM in layoutBorderBadges(); load it before product-main.js.
 *
 * Money values are integer cents in the shop currency, Kaching's own convention.
 */
(function () {
  'use strict';
  if (window.KikaKaching) return;
  const K = {};

  const SVGS = {
    check: "<svg width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M13.3307 4L5.9974 11.3333L2.66406 8\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path></svg>",
    dot: "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><circle cx=\"12\" cy=\"12\" r=\"3\" fill=\"currentColor\"></circle></svg>",
    arrow: "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M5 12H19M19 12L12 5M19 12L12 19\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path></svg>",
    star: "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M11.2787 3.45332C11.5092 2.98638 11.6245 2.75291 11.7809 2.67831C11.917 2.61341 12.0752 2.61341 12.2113 2.67831C12.3677 2.75291 12.483 2.98638 12.7135 3.45332L14.9002 7.88328C14.9682 8.02113 15.0022 8.09006 15.0519 8.14358C15.096 8.19096 15.1488 8.22935 15.2074 8.25662C15.2736 8.28742 15.3497 8.29854 15.5018 8.32077L20.3931 9.03571C20.9082 9.11099 21.1657 9.14863 21.2849 9.27444C21.3886 9.38389 21.4373 9.5343 21.4176 9.68377C21.3949 9.85558 21.2085 10.0372 20.8356 10.4004L17.2975 13.8464C17.1873 13.9538 17.1321 14.0076 17.0965 14.0715C17.065 14.128 17.0448 14.1902 17.037 14.2545C17.0282 14.3271 17.0412 14.403 17.0672 14.5547L17.9021 19.4221C17.9901 19.9355 18.0341 20.1922 17.9514 20.3445C17.8794 20.477 17.7514 20.57 17.6032 20.5975C17.4327 20.6291 17.2022 20.5078 16.7412 20.2654L12.3685 17.9658C12.2322 17.8942 12.1641 17.8584 12.0923 17.8443C12.0288 17.8318 11.9634 17.8318 11.8999 17.8443C11.8281 17.8584 11.76 17.8942 11.6237 17.9658L7.25102 20.2654C6.79001 20.5078 6.55951 20.6291 6.38907 20.5975C6.24078 20.57 6.11282 20.477 6.04083 20.3445C5.95809 20.1922 6.00212 19.9355 6.09017 19.4221L6.92498 14.5547C6.95101 14.403 6.96402 14.3271 6.95521 14.2545C6.94742 14.1902 6.92721 14.128 6.8957 14.0715C6.86012 14.0076 6.80497 13.9538 6.69468 13.8464L3.15665 10.4004C2.78376 10.0372 2.59731 9.85558 2.57462 9.68377C2.55488 9.5343 2.60365 9.38389 2.70734 9.27444C2.82653 9.14863 3.08407 9.11099 3.59914 9.03571L8.4904 8.32077C8.64252 8.29854 8.71857 8.28742 8.78481 8.25662C8.84346 8.22935 8.89626 8.19096 8.94028 8.14358C8.99 8.09006 9.02402 8.02113 9.09207 7.88328L11.2787 3.45332Z\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path></svg>",
    heart: "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M11.9932 5.13581C9.9938 2.7984 6.65975 2.16964 4.15469 4.31001C1.64964 6.45038 1.29697 10.029 3.2642 12.5604C4.89982 14.6651 9.84977 19.1041 11.4721 20.5408C11.6536 20.7016 11.7444 20.7819 11.8502 20.8135C11.9426 20.8411 12.0437 20.8411 12.1361 20.8135C12.2419 20.7819 12.3327 20.7016 12.5142 20.5408C14.1365 19.1041 19.0865 14.6651 20.7221 12.5604C22.6893 10.029 22.3797 6.42787 19.8316 4.31001C17.2835 2.19216 13.9925 2.7984 11.9932 5.13581Z\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path></svg>",
    thumbs: "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M7 22V11M2 13V20C2 21.1046 2.89543 22 4 22H17.4262C18.907 22 20.1662 20.9197 20.3914 19.4562L21.4683 12.4562C21.7479 10.6389 20.3418 9 18.5032 9H15C14.4477 9 14 8.55228 14 8V4.46584C14 3.10399 12.896 2 11.5342 2C11.2093 2 10.915 2.1913 10.7831 2.48812L7.26394 10.4061C7.10344 10.7673 6.74532 11 6.35013 11H4C2.89543 11 2 11.8954 2 13Z\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path></svg>",
    lock: "<svg width=\"100\" height=\"100\" viewBox=\"0 0 100 100\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M44.584 21H42.834V14C42.834 6.279 36.555 0 28.834 0C21.113 0 14.834 6.279 14.834 14V21H13.084C10.1907 21 7.83398 23.3543 7.83398 26.25V50.75C7.83398 53.6457 10.1907 56 13.084 56H44.584C47.4773 56 49.834 53.6457 49.834 50.75V26.25C49.834 23.3543 47.4773 21 44.584 21ZM19.5007 14C19.5007 8.85267 23.6867 4.66667 28.834 4.66667C33.9813 4.66667 38.1673 8.85267 38.1673 14V21H19.5007V14ZM31.1673 39.018V44.3333C31.1673 45.6213 30.1243 46.6667 28.834 46.6667C27.5436 46.6667 26.5007 45.6213 26.5007 44.3333V39.018C25.1123 38.2083 24.1673 36.7197 24.1673 35C24.1673 32.4263 26.2603 30.3333 28.834 30.3333C31.4076 30.3333 33.5007 32.4263 33.5007 35C33.5007 36.7197 32.5557 38.2083 31.1673 39.018Z\" fill=\"currentColor\" transform=\"translate(21.5, 22)\"></path></svg>",
    hint: "<svg viewBox=\"0 0 361 163\" fill=\"none\" aria-hidden=\"true\"><path class=\"kb-scratch__hint-path\" d=\"M22 113.859C23.9107 84.035 22.7293 20.8901 54.8299 45.9835C94.9555 77.3502 81.1193 164.847 101.209 103.575C108.48 64.2518 127.202 -4.91471 143.923 33.0046C164.824 80.4037 155.535 144.223 184.564 113.859C213.593 83.495 160.179 15.685 201.982 45.9835C243.784 76.2821 263.524 183.445 278.619 122.651C293.714 61.8562 268.168 7.24414 303.004 33.0046C337.839 58.765 330.872 64.2534 339 92.7687\" stroke=\"white\" stroke-opacity=\"0.7\" stroke-width=\"44\" stroke-linecap=\"round\"></path></svg>",
    popular: "<svg width=\"102\" height=\"60\" viewBox=\"0 0 102 60\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><ellipse cx=\"47.9\" cy=\"23.5\" rx=\"47.9\" ry=\"23.5\" transform=\"matrix(.9929 .11897 -.14278 .98975 6.7 2)\" fill=\"currentColor\"></ellipse><ellipse cx=\"47.9\" cy=\"23.5\" rx=\"47.9\" ry=\"23.5\" transform=\"matrix(.9929 .11897 -.14278 .98975 6.7 2)\" fill=\"#000\" fill-opacity=\".3\"></ellipse><mask id=\"a\" style=\"mask-type:alpha\" maskUnits=\"userSpaceOnUse\" x=\"3\" y=\"5\" width=\"96\" height=\"48\"><ellipse cx=\"47.9\" cy=\"23.5\" rx=\"47.9\" ry=\"23.5\" transform=\"matrix(.9929 .11897 -.14278 .98975 6.7 0)\" fill=\"currentColor\"></ellipse></mask><g mask=\"url(#a)\"><ellipse cx=\"47.9\" cy=\"23.5\" rx=\"47.9\" ry=\"23.5\" transform=\"matrix(.9929 .11897 -.14278 .98975 6.7 0)\" fill=\"currentColor\"></ellipse></g><path class=\"most-popular-text\" d=\"M28 15.4 25.4 24a.3.3 0 0 1 0 .1.2.2 0 0 1-.2.1c-.4.1-.7 0-.8-.4a1007.3 1007.3 0 0 1-3.9-9.2l-.8 7.6a.5.5 0 0 0 0 .2l.6.8a.7.7 0 0 1 0 .1.2.2 0 0 1 0 .1c0 .5-1.7.1-2 0-1 0 .1-1 .2-1.4l1.1-9c0-.4-.1-.7-.5-1a.4.4 0 0 1-.1-.2v-.2a.2.2 0 0 1 .1 0 15.2 15.2 0 0 1 3.1.2h.1c.1 0 0 0 0 .1.3.5-.5.7-.3 1.2a1361.6 1361.6 0 0 1 3.2 8.1l2.3-7.3a.7.7 0 0 0-.1-.6c-.3-.4-1-1 .1-1l2.7.4c.2 0 .3.2.2.4a.4.4 0 0 1-.1.2c-.3.3-.5.5-.4 1a771.7 771.7 0 0 0 2.5 10c.5.5.7 1-.3.8l-2.2-.3c-.5 0-.5-.4-.1-1a.7.7 0 0 0 .1-.6l-1.6-7.6c0-.2-.1-.2-.1 0zm24 4.7.1 4.5c0 1 .6 1.5 1.6 1.5.3 0 .5-.2.6-.5.1-.4.3-.5.5-.3h.1v.1c.1 1.1-.4 2-1.5 2-2.3.4-3.2-1.2-3.3-3.3l-.2-4.1c0-.4-.2-.5-.6-.5-.5 0-.8-.1-.7-.7a.2.2 0 0 1 .2-.1c1.3.2 2-.3 2-1.6a.2.2 0 0 1 .2-.1c1.1-.5.9 1.3.9 1.9a.1.1 0 0 0 .1.1l2.2.3.2.1c.1.3.1.5-.1.7a.2.2 0 0 1-.1 0 .4.4 0 0 1-.1 0l-2-.1a.1.1 0 0 0-.1 0zm-11.6 4.6c-.7.8-1.8 1.2-3 1.1-1.1 0-2.3-.5-3.3-1.4A5.7 5.7 0 0 1 33 23a5 5 0 0 1-.6-1.7 4 4 0 0 1 .1-1.7c.1-.5.4-1 .8-1.4.7-.7 1.7-1.2 2.9-1.1 1.2 0 2.4.6 3.3 1.4.5.4.9 1 1.2 1.5.3.5.5 1.1.5 1.7a4 4 0 0 1 0 1.6c-.2.6-.5 1-.8 1.4zm-2.4.4c.3 0 .5-.3.7-.5l.5-1v-1.4a6.4 6.4 0 0 0-.3-1.4 6.4 6.4 0 0 0-.6-1.4 4.7 4.7 0 0 0-.8-1 2.6 2.6 0 0 0-1-.6 1.5 1.5 0 0 0-.9 0c-.3 0-.5.3-.7.5l-.4 1a4.7 4.7 0 0 0 0 1.4 6.4 6.4 0 0 0 1.7 3.8c.3.3.6.5 1 .6.2 0 .5.1.8 0zm8-6c-1-.8-2.4-.4-2.3 1 0 .4.3.8.7 1l3 1.2c1.1.5 2.2 2.5 1.1 3.6-1.6 1.8-5.6.6-6.8-1.3-.2-.4-.1-.8.4-1 1.2-.5 1.5 1.5 2.3 2 1 .8 3 .6 2.4-1.1-.3-1-3.2-1.8-3.8-2.2-1.9-1.2-1.8-4 .8-4.3 1.6-.1 4.5.6 4.7 2.6a.3.3 0 0 1 0 .3c-1.1 1.3-1.9-1.3-2.5-1.8zM28.3 34.9c0 1.4 0 2 .8 3 .2.2.2.4 0 .6a.3.3 0 0 1-.2 0l-3.8-.3a.4.4 0 0 1-.3 0c-.3-.4-.3-.7 0-1a1 1 0 0 0 .4-.8L25 28c0-.4-.3-.9-.8-1.4a.3.3 0 0 1 0-.1.2.2 0 0 1 0-.1c0-.3.2-.4.6-.3 3.4.2 9.4.1 9.7 4.8.3 3.8-3 4.1-6 3.9zm-.2-6.7c0 1.4 0 3 .2 4.6 0 .3.2.5.5.6 3.4 1 2.5-3.2 1.6-4.6-.3-.5-.8-.9-1.5-1.1-.5-.2-.8 0-.8.5zM59.5 41c-1.7 1.3-4.3.4-5.2-1.4-1-1.8 0-4.1-1.3-5.8a.4.4 0 0 1 0-.2c0-.6.4-.5.8-.5a19.9 19.9 0 0 1 2.5 0 .4.4 0 0 1 .4.3l.2 5.3c0 .8.3 1.8 1.1 1.8 1.7.2 1-4.2 1-5.3a.5.5 0 0 0-.2-.2l-.5-.8c-.3-.3-.2-.5.3-.6h2.9c.3 0 .4 0 .4.4l.3 6c0 1.6 1.4 1.6 1.3-.2l-.3-7c0-.8-.3-1.2-.8-1.8a.3.3 0 0 1 0-.2.3.3 0 0 1 0-.2.3.3 0 0 1 .2 0l2.8-1.2c.5-.2.8 0 .8.6l.5 10.4c0 .5.2.8.6 1.2.3.4.4 1-.4.8-.9 0-3.1 0-3.9-.4a.4.4 0 0 0-.2 0c-.9 0-2.7.1-3.1-1a.1.1 0 0 0-.2 0zm-16.4-3c-.5 1-1.5 1.6-2.7 1.8-1.2.2-2.5 0-3.6-.7a5.7 5.7 0 0 1-1.5-1.2 5 5 0 0 1-.9-1.6 4.2 4.2 0 0 1-.2-1.7 3.5 3.5 0 0 1 .5-1.6c.5-.9 1.5-1.5 2.7-1.7 1.2-.2 2.5 0 3.6.7a5.7 5.7 0 0 1 1.4 1.2c.5.5.8 1 1 1.6.2.5.2 1.1.2 1.7a3.5 3.5 0 0 1-.5 1.5zm-3.3 1c.2 0 .3-.1.4-.4l.3-.8v-1.3a8.8 8.8 0 0 0-.3-1.3 8.8 8.8 0 0 0-.5-1.3 5.9 5.9 0 0 0-.6-1.1l-.6-.6c-.2-.2-.4-.2-.6-.2-.2 0-.3.2-.4.4l-.3 1v1.1a8.8 8.8 0 0 0 1.4 3.8l.6.6c.2.1.4.2.6.1z\" fill=\"#FEFDFD\"></path><path class=\"most-popular-text\" d=\"M46.9 32.7a3 3 0 0 1 2.8-.3c2.5.8 3.6 2.5 3.5 5-.2 2.9-3.2 4.2-5.5 2.9-.2-.1-.2 0-.2 0 .1 1-.2 2.2.7 3 .3.2.4.5.1.7a.3.3 0 0 1-.2.1 401 401 0 0 0-3.5-.3c-.4 0-.6-.3-.7-.6a.3.3 0 0 1 0-.1.5.5 0 0 1 .1-.1l.5-.7a.4.4 0 0 0 0-.2l-.2-7.3c0-.6-1.1-.9-.9-1.6a.3.3 0 0 1 .2-.2l2.6-1a.2.2 0 0 1 .2 0c.2.1.4.4.4.7zM49 40c2.2 0 .5-5.5-.1-6.4-.7-.8-1.5-.7-1.7.4v3.4c.2.9.6 2.6 1.8 2.6zm24.5 2.7c-2.7 1.4-5.7-1-6.1-3.7-.7-3.5 2.8-5.8 5.8-3.8a.1.1 0 0 0 .1 0c.3-.7 2.3 0 2.9.2.4 0 .6.3.5.7a.3.3 0 0 1 0 .1.3.3 0 0 1-.1 0c-.4.4-.6.8-.6 1.2 0 2.3.2 3.7.2 4.2s1 1.2.7 1.7a.2.2 0 0 1-.1 0 .3.3 0 0 1-.2.1l-2.6-.3a.3.3 0 0 1-.2 0l-.2-.4a.1.1 0 0 0-.1 0zm-.4-5.2c-.2-1.8-2.7-3.4-2.8-.7-.1 1.5.3 4.6 1.9 5.5a.4.4 0 0 0 .2 0c1.4-.3.8-3.5.7-4.8zM80.5 36.5c.3-.3.5-.7 1-.9 3.8-1.6 3.6 4.9.9 2.9-.5-.4-.5-1.7-1.2-1.5a.3.3 0 0 0-.1 0 .3.3 0 0 0 0 .2c-.4.7-.4 4.6.1 5.2.2.3 1.5 1.2.2 1.2a52 52 0 0 1-3.5-.3c-.3 0-.5-.2-.5-.5a.4.4 0 0 1 0-.2c.4-.4.6-.7.6-1.2l-.2-3.5a.4.4 0 0 0 0-.2l-.9-1c-.2-.2 0-.4.3-.6l2.6-1c.3 0 .5 0 .5.4v1h.2z\" fill=\"#FEFDFD\"></path><path class=\"most-popular-text\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"m82.2 24.2-.7-6.2-.7 6.2-2.7-2.1 2 2.7-6.1.7 6.2.7L78 29l2.8-2.1.7 6.1.7-6.1L85 29l-2.2-2.8 6.2-.7-6.1-.7 2-2.7-2.7 2.1z\" fill=\"#fff\"></path><path class=\"most-popular-text\" d=\"M45 4v1a2 2 0 0 0 2 2h1-1a2 2 0 0 0-2 2v1-1a2 2 0 0 0-2-2h-1 1a2 2 0 0 0 2-2V4zm12 41v1a2 2 0 0 0 2 2h1-1a2 2 0 0 0-2 2v1-1a2 2 0 0 0-2-2h-1 1a2 2 0 0 0 2-2v-1zM13 22v3a4 4 0 0 0 4 4h3-3a4 4 0 0 0-4 4v3-3a4 4 0 0 0-4-4H6h3a4 4 0 0 0 4-4v-3zM67 4v3a4 4 0 0 0 4 4h3-3a4 4 0 0 0-4 4v3-3a4 4 0 0 0-4-4h-3 3a4 4 0 0 0 4-4V4z\" fill=\"#fff\"></path></svg>",
  };

  K.ICONS = {
    checkmark: SVGS.check, dot: SVGS.dot, arrow: SVGS.arrow, star: SVGS.star, heart: SVGS.heart, 'thumbs-up': SVGS.thumbs,
  };
  K.LOCK_SVG = SVGS.lock;
  K.SCRATCH_HINT_SVG = SVGS.hint;

  K.esc = (s) => String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');

  // ---------------------------------------------------------------------------------------------
  // Colours. Deal settings hold {red, green, blue, alpha} objects or "brand_<name>" tokens that
  // the shop's brand palette (#kaching-bundles-config brandColors) resolves.
  // ---------------------------------------------------------------------------------------------
  const BRAND_KEYS = ['primaryBackground', 'secondaryBackground', 'primaryText', 'secondaryText', 'border', 'overlay',
    'primaryAccent', 'primaryAccentText', 'badgeBackground', 'badgeText', 'error'];
  const BRAND_DEFAULT = {
    primaryBackground: '#EDEDED', secondaryBackground: '#FFFFFF', primaryText: '#000000', secondaryText: '#555555',
    border: '#0000004D', overlay: '#000000', primaryAccent: '#000000', primaryAccentText: '#FFFFFF',
    badgeBackground: '#000000', badgeText: '#FFFFFF', error: '#D72C2C',
  };

  const hexToColor = (hex) => {
    const p = String(hex).slice(1).match(/../g).map((x) => parseInt(x, 16));
    return { red: p[0], green: p[1], blue: p[2], alpha: p.length > 3 ? p[3] / 255 : 1 };
  };

  K.resolveBrand = function resolveBrand(v, brand) {
    if (typeof v === 'string' && v.indexOf('brand_') === 0 && BRAND_KEYS.indexOf(v.slice(6)) !== -1) {
      const key = v.slice(6);
      return hexToColor((brand && brand[key]) || BRAND_DEFAULT[key]);
    }
    if (Array.isArray(v)) return v.map((x) => resolveBrand(x, brand));
    if (v && typeof v === 'object') {
      const out = {};
      Object.keys(v).forEach((k) => { out[k] = resolveBrand(v[k], brand); });
      return out;
    }
    return v;
  };

  K.rgba = (c) => (c && typeof c === 'object' && c.red != null
    ? 'rgba(' + c.red + ', ' + c.green + ', ' + c.blue + ', ' + (c.alpha == null ? 1 : c.alpha) + ')' : '');

  // "bold italic" -> weight / style, as the widget maps font styles.
  K.fontWeight = (style) => {
    const s = String(style || '');
    const map = { bold: 'bold', light: '300', medium: '500', regular: 'normal' };
    for (const k in map) if (s.indexOf(k) !== -1) return map[k];
    return 'normal';
  };
  K.fontStyle = (style) => (String(style || '').indexOf('italic') !== -1 ? 'italic' : 'normal');

  // "--name:value;" pairs for the entries that have a value (Kaching's _n()).
  K.vars = (o) => Object.keys(o).filter((k) => o[k]).map((k) => '--' + k + ':' + o[k]).join(';');

  // ---------------------------------------------------------------------------------------------
  // Money, in the shop's own money format (the widget's price formatter).
  // ---------------------------------------------------------------------------------------------
  const MONEY_LOCALES = {
    amount: (n) => n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
    amount_no_decimal: (n) => n.toLocaleString('en-US', { maximumFractionDigits: 0 }),
    amount_no_decimals: (n) => n.toLocaleString('en-US', { maximumFractionDigits: 0 }),
    amount_with_comma_separator: (n) => n.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
    amount_no_decimals_with_comma_separator: (n) => n.toLocaleString('de-DE', { maximumFractionDigits: 0 }),
    amount_with_apostrophe_separator: (n) => n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(/,/g, "'"),
    amount_no_decimals_with_space_separator: (n) => n.toLocaleString('fr-FR', { maximumFractionDigits: 0 }).replace(/\s/g, ' '),
    amount_with_space_separator: (n) => n.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(/\s/g, ' '),
    amount_with_period_and_space_separator: (n) => n.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(/\s/g, ' ').replace(',', '.'),
  };

  K.moneyFormatter = (moneyFormat, noDecimals) => {
    const format = moneyFormat || '€{{amount_with_comma_separator}}';
    return (cents, opts) => {
      // preserveDecimals keeps cents on unit prices ("1,67 / kg") unless the amount is whole.
      const strip = noDecimals && (!(opts && opts.preserveDecimals) || Math.round(cents) % 100 === 0);
      const f = strip
        ? (format.indexOf('amount_no_decimals') !== -1 ? format : format.replace(/\{\{.+\}\}/g, '{{ amount_no_decimals }}'))
        : format;
      const re = /{{\s*(\w+)\s*}}/;
      const m = f.match(re);
      const text = (MONEY_LOCALES[m ? m[1] : 'amount'] || MONEY_LOCALES.amount)(cents / 100);
      return f.replace(re, text);
    };
  };

  // ---------------------------------------------------------------------------------------------
  // Selling plans and prices. A "product" is Kaching's shape (see normalizeProduct): variants carry
  // sellingPlans [{id, price, ...}], the product carries sellingPlans [{id, name, priceAdjustment}].
  // ---------------------------------------------------------------------------------------------
  // The variant's price under a plan.
  K.planPrice = (variant, plan) => {
    if (plan) {
      const sp = variant.sellingPlans.find((s) => s.id === plan.id);
      if (sp && sp.price != null) return sp.price;
    }
    return variant.price;
  };

  K.applyAdjustment = (price, plan) => {
    const a = plan && plan.priceAdjustment;
    if (!a) return price;
    if (a.type === 'percentage') return price * (1 - a.value / 100);
    if (a.type === 'fixed_amount') return price - a.value;
    if (a.type === 'price') return a.value;
    return price;
  };

  // The plan to use for `variant` of `product` when the shopper chose `plan` on ANOTHER product /
  // variant: same plan id, else the same plan name, else the variant's first plan (Kaching's rr()).
  // A product that requires a plan falls back to its first one.
  K.planFor = (product, variant, plan) => {
    let match;
    if (plan && variant.sellingPlans.length) {
      const ids = variant.sellingPlans.map((s) => s.id);
      match = ids.indexOf(plan.id) !== -1
        ? product.sellingPlans.find((s) => s.id === plan.id)
        : product.sellingPlans.find((s) => ids.indexOf(s.id) !== -1 && s.name === plan.name) ||
          product.sellingPlans.find((s) => s.id === variant.sellingPlans[0].id);
    }
    if (match) return match;
    if (!product.requiresSellingPlan || !variant.sellingPlans.length) return undefined;
    return product.sellingPlans.find((s) => s.id === variant.sellingPlans[0].id);
  };

  // The plans a variant can be bought with.
  K.plansOf = (product, variants) => product.sellingPlans.filter((p) => variants.some((v) => v.sellingPlans.some((s) => s.id === p.id)));

  // Price rounding ("priceRounding" + "priceRoundingPrecision"): round UP to .00 / .99 / .95 / .90 / .x9 / .x0.
  K.roundTo = (n, precision) => {
    switch (precision) {
      case '.99': return n > 99 ? 100 * Math.ceil(n / 100) - 1 : n;
      case '.95': return n > 95 ? 100 * Math.ceil(n / 100) - 5 : n;
      case '.90': return n > 90 ? 100 * Math.ceil(n / 100) - 10 : n;
      case '.x9': return n > 9 ? 10 * Math.ceil(n / 10) - 1 : n;
      case '.x0': return 10 * Math.ceil(n / 10);
      default: return 100 * Math.ceil(n / 100);
    }
  };

  const roundWhole = (n, items, r) => (r.perItem ? K.roundTo(n / items, r.precision) * items : K.roundTo(n, r.precision));

  // The deal's rounding settings as Kaching passes them on: undefined when rounding is off.
  K.roundingOf = (deal, cfg) => (deal.priceRounding ? {
    perItem: !!deal.showPricesPerItem,
    precision: deal.priceRoundingPrecision,
    v2: !!(cfg && cfg.featureFlags && cfg.featureFlags.price_rounding_v2),
  } : undefined);

  // What the checkout Function charges for `variantQuantities` [{variant, quantity}] under one
  // discount (Kaching's wa()). discountQuantity = the bar quantity the "specific" price is for.
  K.discountedTotal = (o) => {
    const sum = o.variantQuantities.reduce((a, x) => a + K.planPrice(x.variant, o.sellingPlan) * x.quantity, 0);
    const items = o.variantQuantities.reduce((a, x) => a + x.quantity, 0);
    const rate = o.currencyRate || 1;
    let total;
    if (o.discountType === 'specific') {
      const raw = 100 * Number(o.discountValue) * rate;
      const per = (items > Number(o.discountQuantity) ? Math.ceil(raw / Number(o.discountQuantity) * items) : raw) / items;
      let t = 0;
      o.variantQuantities.forEach((x) => {
        const planned = o.sellingPlan && x.variant.sellingPlans.some((s) => s.id === o.sellingPlan.id) && o.sellingPlan.priceAdjustment;
        t += (planned ? K.applyAdjustment(per, o.sellingPlan) : per) * x.quantity;
      });
      total = Math.max(0, Math.min(t, sum));
    } else if (o.discountType === 'percentage') {
      if (o.centsWorkaround) {
        total = Math.max(0, Math.min(Math.ceil(sum * (100 - Number(o.discountValue)) / 100), sum));
      } else {
        let t = 0;
        o.variantQuantities.forEach((x) => { t += Math.ceil(K.planPrice(x.variant, o.sellingPlan) * (100 - Number(o.discountValue)) / 100) * x.quantity; });
        total = Math.max(0, Math.min(t, sum));
      }
    } else if (o.discountType === 'amount') {
      const per = Math.round(100 * Number(o.discountValue)) * rate;
      total = Math.max(0, Math.min(sum - per * items, sum));
    } else total = sum;
    const r = o.priceRounding;
    if (r && (o.discountType !== 'default' || r.v2)) {
      const plain = o.variantQuantities.reduce((a, x) => a + (r.v2 ? K.planPrice(x.variant, o.sellingPlan) : x.variant.price) * x.quantity, 0);
      const planned = o.variantQuantities.reduce((a, x) => a + K.planPrice(x.variant, o.sellingPlan) * x.quantity, 0);
      if (r.perItem) {
        const h = roundWhole(total, items, r);
        return r.v2 && Math.round(h) > Math.round(plain) && total / items > 100
          ? K.roundTo(total / items - 100, r.precision) * items
          : Math.min(h <= plain ? h : total, planned);
      }
      const h = roundWhole(total, items, r);
      return r.v2 && Math.round(h) > Math.round(plain) && total > 100
        ? K.roundTo(total - 100, r.precision)
        : Math.min(h <= plain ? h : total, planned);
    }
    return total;
  };

  // Quantity-break bar.
  K.breakTotal = (bar, vq, rate, rounding, plan, centsWorkaround) => K.discountedTotal({
    discountType: bar.discountType, discountValue: bar.discountValue, discountQuantity: bar.quantity,
    variantQuantities: vq, currencyRate: rate, priceRounding: rounding, sellingPlan: plan, centsWorkaround: centsWorkaround,
  });

  // BXGY bar: the cheapest `getQuantity` units take the "get" discount, the rest the "buy" one.
  K.bxgySplit = (vq, getQuantity) => {
    const sorted = vq.slice().sort((a, b) => a.variant.price - b.variant.price);
    const buy = [], get = [];
    let left = getQuantity;
    sorted.forEach((x) => {
      const g = Math.min(left, x.quantity);
      const b = x.quantity - g;
      if (g > 0) get.push({ variant: x.variant, product: x.product, quantity: g });
      if (b > 0) buy.push({ variant: x.variant, product: x.product, quantity: b });
      left -= g;
    });
    return { buy: buy, get: get };
  };

  K.bxgyTotal = (bar, vq, rate, rounding, plan) => {
    const totalQty = vq.reduce((a, x) => a + x.quantity, 0);
    const getQty = totalQty >= Number(bar.buyQuantity) + Number(bar.getQuantity) ? Number(bar.getQuantity) : 0;
    const parts = K.bxgySplit(vq, getQty);
    const got = parts.get.length ? K.discountedTotal({
      discountType: bar.getDiscountType || 'percentage', discountValue: bar.getDiscountValue != null ? bar.getDiscountValue : 100,
      discountQuantity: getQty, variantQuantities: parts.get, currencyRate: rate, priceRounding: rounding, sellingPlan: plan,
    }) : 0;
    const buyQty = parts.buy.reduce((a, x) => a + x.quantity, 0);
    return got + K.discountedTotal({
      discountType: bar.buyDiscountType || 'default', discountValue: bar.buyDiscountValue != null ? bar.buyDiscountValue : 0,
      discountQuantity: buyQty, variantQuantities: parts.buy, currencyRate: rate, priceRounding: rounding, sellingPlan: plan,
    });
  };

  // Bundle bar: each bundle product has its own discount. sel[bundleProduct.id] = {product, variant, quantity}.
  K.bundleTotal = (bar, sel, rate, rounding, plan) => bar.bundleProducts.filter((b) => b.productGID).map((b) => {
    const s = sel[b.id];
    if (!s) return 0;
    return K.discountedTotal({
      discountType: b.discountType, discountValue: b.discountValue, discountQuantity: b.quantity,
      variantQuantities: [s], currencyRate: rate, priceRounding: rounding, sellingPlan: K.planFor(s.product, s.variant, plan),
    });
  }).reduce((a, x) => a + x, 0);

  // Mix-and-match bar: one discount over the whole set. sel[slot.id] = {product, variant}.
  K.mixTotal = (bar, sel, rate, rounding, plan) => {
    const basis = bar.bundleProducts.filter((b) => b.productGID).reduce((a, b) => {
      const s = sel[b.id];
      if (!s) return a;
      const p = K.planFor(s.product, s.variant, plan);
      return a + (p ? K.applyAdjustment(s.variant.price, p) : s.variant.price);
    }, 0);
    const v = Number(bar.discountValue) || 0;
    let t;
    if (bar.discountType === 'percentage') t = basis * (1 - Math.min(Math.max(v, 0), 100) / 100);
    else if (bar.discountType === 'amount') t = basis - Math.round(100 * v) * rate;
    else if (bar.discountType === 'specific') t = Math.round(100 * v) * rate;
    else t = basis;
    t = Math.max(0, Math.min(t, basis));
    if (rounding && (bar.discountType !== 'default' || rounding.v2)) {
      const before = t;
      let rounded = K.roundTo(before, rounding.precision);
      if (rounding.v2 && Math.round(rounded) > Math.round(basis) && before > 100) rounded = K.roundTo(before - 100, rounding.precision);
      t = rounded <= basis ? rounded : before;
    }
    return Math.max(0, Math.round(t));
  };

  // Mix-and-match "show product prices": the set's price split over its products in proportion to
  // their (plan-adjusted) prices, whole cents, the leftover cents to the largest remainders (Kaching's he()).
  // Returns {slotId: {discountedPrice, fullPrice}}.
  K.mixShares = (bar, sel, rate, rounding, plan) => {
    const rows = bar.bundleProducts.filter((b) => b.productGID).flatMap((b) => {
      const s = sel[b.id];
      if (!s) return [];
      const p = K.planFor(s.product, s.variant, plan);
      return [{ id: b.id, basis: p ? K.applyAdjustment(s.variant.price, p) : s.variant.price, full: s.variant.price }];
    });
    const sum = rows.reduce((a, r) => a + r.basis, 0);
    const out = {};
    if (sum === 0) { rows.forEach((r) => { out[r.id] = { discountedPrice: 0, fullPrice: r.full }; }); return out; }
    const total = K.mixTotal(bar, sel, rate, rounding, plan);
    const parts = rows.map((r) => { const x = total * r.basis / sum; return { r: r, share: Math.floor(x), rem: x % 1 }; });
    let left = total - parts.reduce((a, p) => a + p.share, 0);
    parts.slice().sort((a, b) => b.rem - a.rem).forEach((p) => { if (left > 0) { p.share += 1; left -= 1; } });
    parts.forEach((p) => { out[p.r.id] = { discountedPrice: p.share, fullPrice: p.r.full }; });
    return out;
  };

  // A bar's / upsell's price rounded the way Kaching charges it: add-on price for ONE product line.
  K.lineTotal = (item, variant, quantity, rate, rounding, plan, centsWorkaround) => K.discountedTotal({
    discountType: item.discountType, discountValue: item.discountValue, discountQuantity: item.quantity || 1,
    variantQuantities: [{ variant: variant, quantity: quantity }], currencyRate: rate, priceRounding: rounding, sellingPlan: plan,
    centsWorkaround: centsWorkaround,
  });

  // ---------------------------------------------------------------------------------------------
  // {{ placeholders }}: variables, optional "+ - * /" arithmetic, unknown -> blank.
  // ---------------------------------------------------------------------------------------------
  const VARS = {
    new_price: (c) => ({ value: c.totalDiscounted / c.quantity, type: 'price' }),
    new_total: (c) => ({ value: c.totalDiscounted, type: 'price' }),
    original_price: (c) => ({ value: c.totalFull / c.quantity, type: 'price' }),
    original_total: (c) => ({ value: c.totalFull, type: 'price' }),
    saved_total: (c) => ({ value: c.totalCompareAt - c.totalDiscounted, type: 'price' }),
    saved_amount: (c) => ({ value: (c.totalCompareAt - c.totalDiscounted) / c.quantity, type: 'price' }),
    quantity: (c) => ({ value: c.quantity, type: 'number' }),
    gifts_count: (c) => (c.freeGiftsCount !== undefined ? { value: c.freeGiftsCount, type: 'number' } : undefined),
    buy_quantity: (c) => {
      if (!c.dealBar || c.dealBar.dealBarType !== 'bxgy') return undefined;
      const set = c.dealBar.buyQuantity + c.dealBar.getQuantity;
      return { value: c.quantity - Math.floor(c.quantity / set) * c.dealBar.getQuantity, type: 'number' };
    },
    get_quantity: (c) => {
      if (!c.dealBar || c.dealBar.dealBarType !== 'bxgy') return undefined;
      const set = c.dealBar.buyQuantity + c.dealBar.getQuantity;
      return { value: Math.floor(c.quantity / set) * c.dealBar.getQuantity, type: 'number' };
    },
    saved_percentage: (c) => {
      const b = c.dealBar;
      if (c.legacySavedPercentage && b && (!b.dealBarType || b.dealBarType === 'quantity-break') && b.discountType === 'percentage') {
        return { value: Math.round(Number(b.discountValue)), type: 'percentage' };
      }
      if (c.totalCompareAt <= 0) return { value: 0, type: 'percentage' };
      let s = (c.totalCompareAt - c.totalDiscounted) / c.totalCompareAt * 100;
      s = Math.round(100 * s) / 100;
      return { value: Math.round(s), type: 'percentage' };
    },
    new_unit_price: (c) => (c.unitQuantity ? { value: c.totalDiscounted / c.unitQuantity, type: 'price', preserveDecimals: true } : undefined),
    saved_per_unit: (c) => (c.unitQuantity ? { value: (c.totalCompareAt - c.totalDiscounted) / c.unitQuantity, type: 'price', preserveDecimals: true } : undefined),
    original_unit_price: (c) => (c.unitQuantity ? { value: c.totalFull / c.unitQuantity, type: 'price', preserveDecimals: true } : undefined),
    unit_quantity: (c) => (c.unitQuantity ? { value: c.unitQuantity, type: 'number' } : undefined),
    selling_plan_discount: (c) => {
      const a = c.sellingPlan && c.sellingPlan.priceAdjustment;
      if (!a) return undefined;
      if (a.type === 'percentage') return a.value <= 0 ? undefined : { value: a.value, type: 'percentage' };
      if (a.type === 'fixed_amount') return a.value <= 0 ? undefined : { value: a.value, type: 'price' };
      if (a.type === 'price') {
        const s = c.totalFull / c.quantity - a.value;
        return s <= 0 ? undefined : { value: s, type: 'price' };
      }
      return undefined;
    },
  };

  // Text variables (not numbers): product titles, variant title, product metafields, plan name.
  const textVar = (name, c) => {
    const pn = name.match(/^product_(\d+)$/);
    if (pn) {
      const p = c.products && (c.products.get ? c.products.get(Number(pn[1])) : c.products[Number(pn[1])]);
      return p ? p.title : undefined;
    }
    switch (name) {
      case 'product': return (c.product && c.product.title) || (c.selectedProductTitles && c.selectedProductTitles.length ? c.selectedProductTitles.join(', ') : undefined);
      case 'variant_title': {
        if (!c.selectedVariants) return undefined;
        const seen = [];
        c.selectedVariants.forEach((x) => {
          const t = K.variantTitle(x.variant);
          if (!t) return;
          const hit = seen.find((s) => s.title === t);
          if (hit) hit.count += x.quantity; else seen.push({ title: t, count: x.quantity });
        });
        if (!seen.length) return undefined;
        return seen.length === 1 && seen[0].count === 1 ? seen[0].title : seen.map((s) => s.count + '× ' + s.title).join(', ');
      }
      case 'metafield': return (c.product && c.product.metafields && c.product.metafields.text) || undefined;
      case 'metafield2': return (c.product && c.product.metafields && c.product.metafields.text2) || undefined;
      case 'metafield3': return (c.product && c.product.metafields && c.product.metafields.text3) || undefined;
      case 'metafield4': return (c.product && c.product.metafields && c.product.metafields.text4) || undefined;
      case 'selling_plan': return (c.sellingPlan && c.sellingPlan.name) || undefined;
      default: return undefined;
    }
  };

  K.variantTitle = (variant) => {
    const t = (variant.options || []).join(' / ');
    return t && t !== 'Default Title' ? t : undefined;
  };

  const PLACEHOLDER = /{{\s*([a-zA-Z0-9_.]+)\s*(?:([+\-*/])\s*(\d+(?:\.\d+)?)?)?\s*}}/g;
  const ANY_BRACES = /\{\{[^}]*\}\}/g;

  K.PLACEHOLDER = PLACEHOLDER;
  K.stripPlaceholders = (s) => String(s || '').replace(ANY_BRACES, '');

  // Fill one string. c = {money, product, products, selectedVariants, totalFull, totalCompareAt,
  // totalDiscounted, quantity, dealBar, unitQuantity, sellingPlan, freeGiftsCount, legacySavedPercentage}.
  K.fill = (str, c) => {
    if (!str) return str;
    if (c.totalCompareAt == null) c = Object.assign({}, c, { totalCompareAt: c.totalFull });
    const value = (name, op, operand) => {
      const def = VARS[name];
      if (def) {
        const r = def(c);
        if (!r) return undefined;
        let v = r.value;
        if (op !== undefined && operand !== undefined) {
          const n = r.type !== 'price' || (op !== '+' && op !== '-') ? operand : 100 * operand;
          if (op === '+') v = v + n;
          else if (op === '-') v = v - n;
          else if (op === '*') v = v * n;
          else if (op === '/') { if (n === 0) return undefined; v = v / n; }
        }
        const keep = op === '/' || r.preserveDecimals === true;
        if (r.type === 'price') return c.money(v, { preserveDecimals: keep });
        if (r.type === 'number') return String(Math.round(100 * v) / 100);
        return Math.round(v) + '%';
      }
      if (op === undefined) return textVar(name, c);
      return undefined;
    };
    // c.wrap marks each substituted value (the savings line highlights them).
    const wrap = (s) => (s && c.wrap ? c.wrap(s) : s);
    return String(str).replace(PLACEHOLDER, (m, name, op, operand) => {
      if (op && operand) {
        const r = value(name, op, parseFloat(operand));
        return r != null ? wrap(r) : '';
      }
      return wrap(value(name) || '');
    }).replace(ANY_BRACES, '');
  };

  // ---------------------------------------------------------------------------------------------
  // Products: the Storefront query and the shape the widget works with.
  // ---------------------------------------------------------------------------------------------
  K.PRODUCT_FIELDS = 'id handle onlineStoreUrl availableForSale createdAt title featuredImage{url} ' +
    'options{name} requiresSellingPlan ' +
    'variants(first:100){nodes{id title availableForSale price{amount} compareAtPrice{amount} selectedOptions{name value} image{url} requiresComponents ' +
      'sellingPlanAllocations(first:20) @include(if:$sp){nodes{sellingPlan{id} priceAdjustments{price{amount} compareAtPrice{amount} perDeliveryPrice{amount}}}} ' +
      'quantityAvailable @include(if:$qty)}} ' +
    'mf1: metafield(namespace:"$app:kaching_bundles", key:"text"){value} mf2: metafield(namespace:"$app:kaching_bundles", key:"text2"){value} ' +
    'mf3: metafield(namespace:"$app:kaching_bundles", key:"text3"){value} mf4: metafield(namespace:"$app:kaching_bundles", key:"text4"){value} ' +
    'sellingPlanGroups(first:10) @include(if:$sp){nodes{sellingPlans(first:20){nodes{id name priceAdjustments{adjustmentValue{__typename ' +
    '... on SellingPlanPercentagePriceAdjustment{adjustmentPercentage} ... on SellingPlanFixedAmountPriceAdjustment{adjustmentAmount{amount}} ' +
    '... on SellingPlanFixedPriceAdjustment{price{amount}}}}}}}}';

  const numId = (gid) => Number(String(gid).split('/').pop());
  K.numId = numId;
  K.gid = (x, type) => (x == null ? null : (String(x).indexOf('gid://') === 0 ? String(x) : 'gid://shopify/' + type + '/' + x));

  // Raw Storefront product (PRODUCT_FIELDS) -> Kaching's product shape.
  K.normalizeProduct = (raw, rate) => {
    const cents = (a) => Math.round(Number(a) * 100);
    const money = (a) => (rate === 1 || rate == null ? Number(a) * 100 : Math.round(Number(a) * 100 * rate));
    const variants = raw.variants.nodes.map((v) => ({
      id: numId(v.id),
      gid: v.id,
      title: v.title,
      availableForSale: v.availableForSale,
      price: cents(v.price.amount),
      compareAtPrice: v.compareAtPrice ? cents(v.compareAtPrice.amount) : null,
      options: (v.selectedOptions || []).map((o) => o.value),
      image: (v.image && v.image.url) || null,
      sellingPlans: ((v.sellingPlanAllocations && v.sellingPlanAllocations.nodes) || []).map((a) => ({
        id: numId(a.sellingPlan.id),
        price: a.priceAdjustments.length ? cents(a.priceAdjustments[0].price.amount) : cents(v.price.amount),
        compareAtPrice: a.priceAdjustments.length ? cents(a.priceAdjustments[0].compareAtPrice.amount) : cents(v.price.amount),
        perDeliveryPrice: a.priceAdjustments.length ? cents(a.priceAdjustments[0].perDeliveryPrice.amount) : cents(v.price.amount),
      })),
      inventoryQuantity: v.quantityAvailable != null ? v.quantityAvailable : null,
    }));
    const adjustment = (p) => {
      const a = p.priceAdjustments && p.priceAdjustments[0];
      if (!a) return null;
      const av = a.adjustmentValue;
      if (av.__typename === 'SellingPlanPercentagePriceAdjustment') return { type: 'percentage', value: av.adjustmentPercentage };
      if (av.__typename === 'SellingPlanFixedAmountPriceAdjustment') return { type: 'fixed_amount', value: money(av.adjustmentAmount.amount) };
      if (av.__typename === 'SellingPlanFixedPriceAdjustment') return { type: 'price', value: money(av.price.amount) };
      return null;
    };
    const plans = [];
    ((raw.sellingPlanGroups && raw.sellingPlanGroups.nodes) || []).forEach((g) => g.sellingPlans.nodes.forEach((p) => {
      plans.push({ id: numId(p.id), name: p.name, priceAdjustment: adjustment(p) });
    }));
    return {
      id: numId(raw.id),
      gid: raw.id,
      handle: raw.handle,
      url: raw.onlineStoreUrl || '/products/' + raw.handle,
      availableForSale: raw.availableForSale,
      createdAt: raw.createdAt || null,
      title: raw.title,
      image: (raw.featuredImage && raw.featuredImage.url) || null,
      options: (raw.options || []).map((o, i) => ({ name: o.name, position: i + 1 })),
      variants: variants,
      requiresSellingPlan: !!raw.requiresSellingPlan,
      sellingPlans: plans,
      isNativeBundle: raw.variants.nodes.some((v) => v.requiresComponents),
      metafields: {
        text: (raw.mf1 && raw.mf1.value) || null, text2: (raw.mf2 && raw.mf2.value) || null,
        text3: (raw.mf3 && raw.mf3.value) || null, text4: (raw.mf4 && raw.mf4.value) || null,
      },
    };
  };

  // Variants of `product` a `variantGIDs` list allows (null / empty = all), available ones only.
  K.allowedVariants = (product, variantGIDs, includeSoldOut) => {
    const ids = variantGIDs && variantGIDs.length ? variantGIDs.map(numId) : null;
    return product.variants.filter((v) => (includeSoldOut || v.availableForSale) && (!ids || ids.indexOf(v.id) !== -1));
  };

  // ---------------------------------------------------------------------------------------------
  // Badges. A badge is {badgeType: simple | most-popular | custom | border, text, ...}; the caller
  // has already translated + placeholder-filled `text`. `media(gid)` resolves a MediaImage GID.
  // ---------------------------------------------------------------------------------------------
  // The legacy single badge on a bar / checkbox upsell, as one new-style badge (Kaching's Ad()).
  K.legacyBadge = (item) => {
    const style = item.badgeStyle || 'simple';
    const text = item.badgeText || '';
    const base = { id: 'legacy-' + item.id, text: text, colors: null };
    if (style === 'most-popular') return Object.assign(base, { badgeType: 'most-popular', size: 102 });
    if (style === 'custom') return item.badgeImageGID ? Object.assign(base, { badgeType: 'custom', imageGID: item.badgeImageGID, size: 56 }) : null;
    return text ? Object.assign(base, { badgeType: 'simple', textSize: 12 }) : null;
  };

  // Badges for one target. Once the deal has badges[] they replace the legacy field entirely.
  // attach: {type:'dealBar', dealBarId} | {type:'checkboxUpsell', upsellId} | {type:'barUpsell', dealBarId, upsellId} | {type:'block'}.
  K.badgesFor = (deal, attach, legacyItem) => {
    if (deal.badgesEnabled === false) return [];
    const all = deal.badges || [];
    if (all.length) {
      return all.filter((b) => {
        const a = b.attachedTo || {};
        if (a.type !== attach.type) return false;
        if (attach.dealBarId !== undefined && a.dealBarId !== attach.dealBarId) return false;
        if (attach.upsellId !== undefined && a.upsellId !== attach.upsellId) return false;
        return true;
      });
    }
    if (!legacyItem || attach.type === 'barUpsell' || attach.type === 'block') return [];
    const l = K.legacyBadge(legacyItem);
    return l ? [l] : [];
  };

  let measureCtx = null;
  const textWidth = (text, size) => {
    if (typeof document === 'undefined') return 0;
    measureCtx = measureCtx || document.createElement('canvas').getContext('2d');
    if (!measureCtx) return 0;
    measureCtx.font = 'bold ' + size + 'px sans-serif';
    return measureCtx.measureText(text).width + 0.5 * text.length;
  };

  // How border badges change the bar's box: which sides, how thick, the gap, the minimum side length.
  K.badgeBox = (badges) => {
    const borders = badges.filter((b) => b.badgeType === 'border');
    const thickness = borders.length ? Math.max.apply(null, borders.map((b) => b.thickness)) : 22;
    const all = borders.filter((b) => b.position === 'all').map((b) => b.gap || 0);
    const side = borders.filter((b) => b.position === 'left' || b.position === 'right').map((b) => textWidth(b.text, b.textSize) + 24);
    const positions = {};
    borders.forEach((b) => { positions[b.position] = true; });
    return { positions: positions, thickness: thickness, gap: all.length ? Math.max.apply(null, all) : 0, sideLength: side.length ? Math.max.apply(null, side) : 0 };
  };

  K.badgeColors = (b, deal) => {
    const own = b.colors && b.colors.text && b.colors.background ? b.colors : null;
    const bg = own ? own.background : (deal && deal.colors && deal.colors.badgeBackground);
    const fg = own ? own.text : (deal && deal.colors && deal.colors.badgeText);
    return (bg ? '--kb-badge-bg:' + K.rgba(bg) + ';' : '') + (fg ? '--kb-badge-color:' + K.rgba(fg) + ';' : '');
  };

  let badgeSeq = 0;
  // Markup for one badge. Border badges that go all the way round ("all", repeating text) are
  // finished by layoutBorderBadges() once they are in the page and measurable.
  K.badgeHTML = (b, deal, media) => {
    const colors = K.badgeColors(b, deal);
    const t = K.esc(b.text || '');
    if (b.badgeType === 'border') {
      const vars = '--kb-border-thickness:' + b.thickness + 'px;--kb-badge-text-size:' + b.textSize + 'px;';
      if (b.position === 'all') {
        const data = ' data-kb-ring data-text="' + t + '" data-thickness="' + b.thickness + '" data-text-size="' + b.textSize + '" data-gap="' + (b.gap || 0) +
          '" data-spacing="' + (b.spacing || 0) + '" data-spin-speed="' + (b.spinSpeed || 0) + '" data-spin-direction="' + K.esc(b.spinDirection || 'clockwise') +
          '" data-delimiter="' + K.esc(b.delimiter || '') + '" data-animated="' + (b.animated ? 1 : 0) + '" data-repeat="' + (b.repeatText ? 1 : 0) + '"';
        return '<div class="kb-badge-border kb-badge-border--all" style="' + colors + vars + '--kb-ring-outer:' + (b.thickness + (b.gap || 0)) + 'px"' + data + '>' +
          '<div class="kb-badge-border__band"><span></span></div>' +
          (b.repeatText && String(b.text || '').trim() ? '' : '<span class="kb-badge-border__side kb-badge-border__side--top">' + t + '</span>') + '</div>';
      }
      return '<div class="kb-badge-border kb-badge-border--' + K.esc(b.position) + '" style="' + colors + vars + '"><span class="kb-badge-border__text">' + t + '</span></div>';
    }
    if (b.badgeType === 'custom') {
      const url = media ? media(b.imageGID) : '';
      if (!url) return '';
      return '<div class="kb-badge kb-badge--custom" style="--kb-badge-size:' + b.size + 'px"><img class="kb-badge__img" src="' + K.esc(url) + '" alt="' + K.esc(b.text || 'Badge') + '"></div>';
    }
    if (b.badgeType === 'most-popular') {
      badgeSeq += 1;
      const svg = SVGS.popular.replace(/id="a"/, 'id="kbmp' + badgeSeq + '"').replace('url(#a)', 'url(#kbmp' + badgeSeq + ')');
      return '<div class="kb-badge kb-badge--fancy" style="' + colors + '--kb-badge-size:' + b.size + 'px">' + svg + '</div>';
    }
    if (!b.text) return '';
    return '<div class="kb-badge kb-badge--simple" style="' + colors + '--kb-badge-text-size:' + b.textSize + 'px"><div class="kb-badge__content">' + t + '</div></div>';
  };

  // Sides the badges put on the bar: modifier classes + the custom properties that make room for them.
  K.badgeBoxAttrs = (badges) => {
    const box = K.badgeBox(badges);
    const sides = Object.keys(box.positions);
    return {
      cls: sides.map((s) => 'has-badge-border-' + s).join(' '),
      style: sides.length ? '--kb-border-thickness:' + box.thickness + 'px;--kb-border-gap:' + box.gap + 'px;--kb-border-gap-border:' +
        (box.gap ? '1px solid rgba(0,0,0,.3)' : 'none') + (box.sideLength ? ';--kb-border-min-length:' + box.sideLength + 'px' : '') : '',
    };
  };

  // Ring badges: draw the repeating text along the bar's border (SVG textPath), sized to the bar.
  K.layoutBorderBadges = (root) => {
    const reduce = typeof window.matchMedia === 'function' && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    root.querySelectorAll('[data-kb-ring]').forEach((el) => {
      if (el.dataset.repeat !== '1') return;
      const draw = () => {
        const text = el.dataset.text.trim();
        const w = el.clientWidth, h = el.clientHeight;
        if (!text || !w || !h) return;
        const thickness = Number(el.dataset.thickness), size0 = Number(el.dataset.textSize), gap = Number(el.dataset.gap);
        const spacing = Number(el.dataset.spacing), speed = Number(el.dataset.spinSpeed);
        const delimiter = el.dataset.delimiter;
        const size = Math.max(6, Math.min(size0, thickness - 6));
        const pad = 0.32 * size;
        const slotPad = 0.4 * size + spacing;
        const slotLen = (textWidth(text, size) || text.length * size * 0.7) + (delimiter ? size : 0) + 2 * slotPad;
        const cs = getComputedStyle(el);
        const radius = parseFloat(cs.getPropertyValue('--kb-bar-radius')) || 8;
        const y = thickness / 2 + pad;
        const xr = w - y, yb = h - y;
        const r = Math.min(radius + gap + y, Math.max(0, Math.min(xr - y, yb - y) / 2));
        const lap = ['H ' + (xr - r), 'A ' + r + ' ' + r + ' 0 0 1 ' + xr + ' ' + (y + r), 'V ' + (yb - r), 'A ' + r + ' ' + r + ' 0 0 1 ' + (xr - r) + ' ' + yb,
          'H ' + (y + r), 'A ' + r + ' ' + r + ' 0 0 1 ' + y + ' ' + (yb - r), 'V ' + (y + r), 'A ' + r + ' ' + r + ' 0 0 1 ' + (y + r) + ' ' + y].join(' ');
        const d = 'M ' + (y + r) + ' ' + y + ' ' + lap + ' ' + lap + ' Z';
        const NS = 'http://www.w3.org/2000/svg';
        const svg = document.createElementNS(NS, 'svg');
        svg.setAttribute('class', 'kb-badge-border__curve');
        svg.setAttribute('viewBox', '0 0 ' + w + ' ' + h);
        const path = document.createElementNS(NS, 'path');
        const id = 'kb-ring-' + (++badgeSeq);
        path.setAttribute('id', id);
        path.setAttribute('d', d);
        path.setAttribute('fill', 'none');
        svg.appendChild(path);
        const pathLength = path.getTotalLength ? path.getTotalLength() / 2 : 0;
        if (pathLength <= 0 || slotLen <= 0) return;
        const count = Math.max(1, Math.floor(pathLength / slotLen));
        const slot = pathLength / count;
        const spin = el.dataset.repeat === '1' && el.dataset.animated === '1' && speed > 0 && !reduce;
        const dur = spin ? Math.max(2, pathLength / Math.max(1, speed)) : 0;
        const clockwise = el.dataset.spinDirection === 'clockwise';
        const addText = (offset, content) => {
          const t = document.createElementNS(NS, 'text');
          t.setAttribute('text-anchor', 'middle');
          const tp = document.createElementNS(NS, 'textPath');
          tp.setAttribute('href', '#' + id);
          tp.setAttribute('startOffset', offset);
          if (spin) {
            const an = document.createElementNS(NS, 'animate');
            an.setAttribute('attributeName', 'startOffset');
            an.setAttribute('repeatCount', 'indefinite');
            an.setAttribute('from', clockwise ? offset : offset + pathLength);
            an.setAttribute('to', clockwise ? offset + pathLength : offset);
            an.setAttribute('dur', dur + 's');
            tp.appendChild(an);
          }
          tp.appendChild(document.createTextNode(content));
          t.appendChild(tp);
          svg.appendChild(t);
        };
        for (let i = 0; i < count; i++) {
          addText(i * slot + slot / 2, el.dataset.text);
          if (delimiter) addText(i * slot + slot, delimiter);
        }
        const old = el.querySelector('.kb-badge-border__curve');
        if (old) old.remove();
        el.appendChild(svg);
      };
      draw();
      if (typeof ResizeObserver === 'function' && !el.kbObserved) {
        el.kbObserved = true;
        new ResizeObserver(() => draw()).observe(el);
      }
    });
  };

  window.KikaKaching = K;
})();
